import { CodeNameModel, FileList } from 'components/common/types';
import { NetworkCriteriaType } from 'components/common/types/DirectSalesNetworks.types';
import { isValueRequired } from 'components/pages/PCM/Products/utils/isValueRequired';
import { Environment, RouteFrameCode, Tag } from 'components/common/types/Deal.types';
import {
  DirectSalesMediaType,
  DirectSalesPricingMode,
  DirectSalesCodeNameModel,
} from 'components/common/types/DirectSalesCampaign.types';
import { POI } from 'components/common/types/Planner.types';

export type ConfirmPanelValue =
  | DirectSalesMediaType
  | NetworkCriteriaType[]
  | DirectSalesPricingMode
  | Environment[]
  | DirectSalesCodeNameModel[]
  | { routeFrameCodes: RouteFrameCode[]; listFiles: FileList[] }
  | POI[]
  | Tag[];

const isArrayValue = (value: unknown): value is unknown[] => Array.isArray(value);

const areValuesEqual = (oldValue: unknown, newValue: unknown): boolean => {
  if (oldValue === newValue) return true;

  if (isArrayValue(oldValue) && isArrayValue(newValue)) {
    return JSON.stringify(oldValue) === JSON.stringify(newValue);
  }

  return false;
};

export const isPanelConfirmDisabled = ({
  field,
  selectedPermission,
  newFieldValue,
}: {
  field?: { value?: ConfirmPanelValue; selectionPermission: string };
  selectedPermission: CodeNameModel;
  newFieldValue?: ConfirmPanelValue;
}): boolean => {
  const permissionUnchanged = field?.selectionPermission === selectedPermission.code;
  const fieldValueUnchanged = areValuesEqual(field?.value, newFieldValue);

  if (isValueRequired(selectedPermission.code)) {
    if (permissionUnchanged && fieldValueUnchanged) {
      return true;
    }

    if (Array.isArray(newFieldValue)) {
      return !newFieldValue.length;
    }

    if (newFieldValue && typeof newFieldValue === 'object' && 'routeFrameCodes' in newFieldValue) {
      return !newFieldValue.routeFrameCodes.length && !newFieldValue.listFiles.length;
    }

    return !newFieldValue;
  }

  if (permissionUnchanged && fieldValueUnchanged) {
    return true;
  }

  if (permissionUnchanged && !fieldValueUnchanged) {
    return false;
  }

  return false;
};
